<template>
  <div class="root" :style="{height: height, width: width}">
    <div class="carousel" ref='carousel' @mouseenter="handleMouseenter" @mouseleave="init">
      <div :style="item.myStyle" class="item" v-for="(item, index) in itemList" :key="index" @touchstart="handleTouchstart" @touchend="handleTouchend">
        <img :alt="'图片'+index" :src="item.imgUrl"/>
        <div class="desc" :class="'home'+index">
          <div v-for="(d, index1) in item.desc" :key="index1">
            {{d}}
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div v-for="(item, index) in imgs" @click="handleClickFooter(index)" :key="index" :class="{active: index === activeIndex}">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Carousel',
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    imgs: {
      type: Array,
      default: () => []
    },
    duration: {
      type: Number,
      default: 5500
    },
    autoPlay: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      activeIndex: 0,
      itemStyle: {},
      interval: '',
      itemList: [],
      currentClientX: 0
    }
  },
  mounted () {
    this.imgs.map((img, index) => {
      const item = {}
      const myStyle = { opacity: index === 0 ? 1 : 0, height: this.height, width: this.width, transform: `translateX(${index * this.$refs.carousel.offsetWidth}px)` }
      item.myStyle = myStyle
      item.imgUrl = img.url
      item.desc = img.desc
      this.itemList.push(item)
    })
    this.autoPlay && this.init()
  },
  destroyed () {
    clearInterval(this.interval)
  },
  methods: {
    init () {
      this.interval = setInterval(() => {
        this.calItemPosition()
      }, this.duration)
    },
    handleMouseenter () {
      clearInterval(this.interval)
    },
    calItemPosition () {
      const { activeIndex } = this
      if (activeIndex < this.itemList.length - 1) {
        this.activeIndex++
      } else {
        this.activeIndex = 0
      }
    },
    handleTouchstart (e) {
      this.currentClientX = e.changedTouches[0].clientX
    },
    handleTouchend (e) {
      const touchendClientX = e.changedTouches[0].clientX
      if (touchendClientX - this.currentClientX <= -50) {
        if (this.activeIndex === this.itemList.length - 1) {
          this.activeIndex = 0
        } else {
          this.activeIndex++
        }
      }
      if (touchendClientX - this.currentClientX >= 50) {
        if (this.activeIndex !== 0) {
          this.activeIndex--
        }
      }
    },
    handleClickFooter (index) {
      clearInterval(this.interval)
      this.activeIndex = index
      this.$nextTick(() => {
        this.autoPlay && this.init()
      })
    }
  },
  watch: {
    activeIndex (newVal, oldVal) {
      this.itemList.map((item, index) => {
        if (newVal === 0) {
          if (oldVal === this.itemList.length - 1) {
            if (index === this.itemList.length - 1) {
              item.myStyle.transform = `translateX(${-1 * this.$refs.carousel.offsetWidth}px)`
              item.myStyle.opacity = 1
            } else {
              item.myStyle.transform = `translateX(${(index - newVal) * this.$refs.carousel.offsetWidth}px)`
              if (index === newVal) {
                item.myStyle.opacity = 1
              } else {
                item.myStyle.opacity = 0
              }
            }
          } else {
            item.myStyle.transform = `translateX(${(index - newVal) * this.$refs.carousel.offsetWidth}px)`
            item.myStyle.opacity = 1
          }
        } else if (newVal === this.itemList.length - 1) {
          if (index === 0) {
            item.myStyle.transform = `translateX(${this.$refs.carousel.offsetWidth}px)`
            item.myStyle.opacity = 0
          } else {
            item.myStyle.transform = `translateX(${(index - newVal) * this.$refs.carousel.offsetWidth}px)`
            item.myStyle.opacity = 1
          }
        } else {
          item.myStyle.transform = `translateX(${(index - newVal) * this.$refs.carousel.offsetWidth}px)`
          if (index === newVal || index === newVal - 1) {
            item.myStyle.opacity = 1
            if (oldVal === this.itemList.length - 1 && index === 0) {
              item.myStyle.opacity = 0
            }
          } else {
            item.myStyle.opacity = 0
          }
        }
        if (newVal === oldVal - 1) {
          if (index === oldVal) {
            item.myStyle.opacity = 1
          }
        }
      })
      this.itemList.map((item, index) => {
        if (index === newVal) {
          item.myStyle.zIndex = 100
        } else {
          item.myStyle.zIndex = 0
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.root{
  position: relative;
  overflow: hidden;
  touch-action:none;
  touch-action:pan-y;
  .carousel{
    position: relative;
    width: 100%;
    height: 100%;
    .item{
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      will-change: transform;
      transition: transform ease-in-out .4s;
      img{
        height: 100%;
        width: 100%;
      }
      .desc{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
      }
    }
  }
  .footer{
    position: absolute;
    left: 50%;
    bottom: .44rem;
    display: flex;
    z-index: 9998;
    transform: translateX(-50%);
    >div{
      cursor: pointer;
      width: 10px;
      height: 10px;
      margin: 0 .07rem;
      // background: white;
      border-radius: 5px;
      border: 2px solid #979797;
      &.active{
        background: #73D6D0;
        border-color: #73D6D0;
      }
    }
  }
}
</style>
